export default "__VITE_ASSET__vyZQOUd6__"